
import { defineComponent } from "vue"
import SocketComponent from "../../services/socket"
import AppMenu from "../../components/app/AppMenu.vue"
import AppBar from "../../components/app/AppBar.vue"

export default defineComponent({
  components: { SocketComponent, AppMenu, AppBar }
})
